// extracted by mini-css-extract-plugin
module.exports = {"close":"src-CanvasClose-close-ef30c287","black":"src-CanvasClose-black-de083f64","white":"src-CanvasClose-white-bb7b7f85","closeIcon":"src-CanvasClose-closeIcon-94769b02"};